// import React, { useState } from 'react';
// import toast from 'react-hot-toast';
// import { FaFileAlt, FaImage, FaUser } from 'react-icons/fa';
// import { MdClose } from 'react-icons/md';


// const TenantPopup = ({
//   tenant,
//   onClose
// }: {
//   tenant: Tenant;
//   onClose: () => void;
// }) => {
//     const [imageToShow, setImageToShow] = useState<string | null>(null);
  
//     const handleImageClick = (tenantImageUrl: string | null) => {
//       if (tenantImageUrl && tenantImageUrl.startsWith("http")) {
//         // Set the image to show inline instead of opening in a new tab
//         setImageToShow(tenantImageUrl);
//       } else {
//         toast.error("No valid image available to view.");
//       }
//     };
  
//     return (
//   <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//     <div className="bg-white p-7 rounded-lg w-96 relative">
//       <button onClick={onClose} className="absolute top-2 right-2 text-red-500">
//         <MdClose size={24} />
//       </button>
//      <div className='flex justify-between  gap-2 w-full border-b py-4 border-primary'>
//      <img
//         src={tenant?.tenantImageUrl || 'https://via.placeholder.com/150'}
//         alt={tenant?.name}
//         className="w-24 h-24 rounded-full mx-auto"
//       />
//       <span className='flex flex-col justify-center  gap-1  w-full'>
//       <h2 className="text-start text-2xl font-bold ">{tenant?.name}</h2>
//       <p className="text-start text-gray-600">{tenant?.occupation}</p>
//       </span>
//      </div>
//       <p className="mt-4"><strong>Phone Number:</strong> {tenant?.
//       contact}</p>
//      {tenant?.email && ( <p><strong>Email:</strong> {tenant?.email}</p> )}
//       {/* <p><strong>Property Address:</strong> {tenant?.propertyAddress.propertyAddress}</p> */}
//       <p><strong>Property Name:</strong> {tenant?.propertyAddress?.propertyName ?? "N/A"}</p>

//       <p><strong>Rent Due Date:</strong> {tenant?.dueDate}</p>
//       <p><strong>Occupied Date:</strong> {tenant?.occupiedDate}</p>
//       {/* <p><strong>Rent Status:</strong> {tenant?.rentStatus}</p> */}
//       <p><strong>Deposit Amount:</strong> &#8377;{tenant?.propertyAddress?.propertyDepositAmount}</p>
//       <p><strong>Rent:</strong>&#8377;{tenant?.propertyAddress?.propertyRent}</p>
//       <p><strong>Opening Balance:</strong> &#8377;{tenant?.openingBalance}</p>

//        <p><strong>Pending Opening Balance:</strong> &#8377;{tenant?.unPaidOpeningBalance}</p>

//         <p><strong>Pending Deposit Amount:</strong> &#8377;{tenant?.unaidDepositAmount}</p>


//       {tenant?.comments && <p><strong>Comments:</strong> {tenant?.comments}</p>}
//       {/* {tenant?.documentUrl && (
//         <p>
//           <strong>Document:</strong> <a href={tenant?.documentUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500">View Document</a>
//         </p>
//       )} */}
//        {tenant?.documentUrl && (
//         <p className="mt-2">
//           <strong>Document:</strong>
//           <button
//             onClick={() => {
//              // console.log("Document URL:", tenant.documentUrl); 
//               if (tenant.documentUrl) {
//                 window.open(tenant.documentUrl, '_blank', 'noopener,noreferrer');
//               } else {
//                 toast.error("No document available to view.");
//               }
//             }}
//             className="text-blue-500 hover:underline ml-1 flex items-center"
//           >
//             <FaFileAlt className="mr-1" /> View Document
//           </button>
//         </p>
//       )}
   
//       </div>
//     </div>
//   );
// };

// export default TenantPopup;

import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { FaFileAlt, FaImage, FaSpinner } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';

// Your existing Tenant type
type Tenant = {
  id: number;
  name: string;
  contact: string;
  email: string;
  propertyAddress: any;
  propertyName?: string;
  dueDate: string;
  occupiedDate: string;
  vacatedDate: string;
  rentStatus: "PAID" | "UNPAID";
  depositAmount: number;
  openingBalance: number | null;
  unPaidOpeningBalance: number | null;
  unaidDepositAmount: number | null;
  rent: number;
  occupation: string;
  documentUrl: string | null;
  comments: string | null;
  tenantImageUrl: string | null;
  active: boolean;
};

// Document Viewer Component (internal to this file)
const DocumentViewer: React.FC<{
  isOpen: boolean;
  url: string;
  type: string;
  tenantId: number; 
  onClose: () => void;
}> = ({ isOpen, url, type, tenantId, onClose }) => {
  const [documentUrl, setDocumentUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchDocument = async (): Promise<string | null> => {
    try {
      const token = localStorage.getItem('R_M_t'); // Your auth token key
      
      // Use the tenantId prop to construct the API URL
      const apiUrl = `https://api.selvamrentalmanagement.space/api/v1/tenants/${tenantId}/document`;
      
      // Call your backend API endpoint to get the document
      const response = await fetch(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch document: ${response.status} ${response.statusText}`);
      }

      // Convert the response to a blob first
      const blob = await response.blob();
      
      // Create object URL from the blob
      const url = URL.createObjectURL(blob);
      console.log('Created document blob URL:', url);
      return url;
    } catch (err) {
      console.error('Error in fetchDocument:', err);
      toast.error('Failed to load document');
      return null;
    }
  };

  useEffect(() => {
    if (isOpen) {
      const loadDocument = async () => {
        setLoading(true);
        setDocumentUrl(null);
        
        try {
          const fetchedUrl = await fetchDocument();
          setDocumentUrl(fetchedUrl);
        } catch (error) {
          console.error('Error loading document:', error);
          toast.error('Failed to load document');
        } finally {
          setLoading(false);
        }
      };
      
      loadDocument();
    }

    return () => {
      // Clean up blob URLs when component unmounts or URL changes
      if (documentUrl && documentUrl.startsWith('blob:')) {
        URL.revokeObjectURL(documentUrl);
      }
    };
  }, [isOpen, tenantId]);

  if (!isOpen) return null;

  const isPdf = type === 'pdf' || url.toLowerCase().endsWith('.pdf');
  const isImage = type === 'image' || 
    ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].some(ext => 
      url.toLowerCase().endsWith(`.${ext}`)
    );

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-lg font-medium">Document Viewer</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            ✕
          </button>
        </div>
        <div className="p-4">
          {loading ? (
            <div className="flex items-center justify-center h-[70vh]">
              <FaSpinner className="animate-spin mr-2 text-2xl" />
              <p>Loading document...</p>
            </div>
          ) : isImage && documentUrl ? (
            <img 
              src={documentUrl} 
              alt="Document" 
              className="max-w-full max-h-[70vh] mx-auto"
              onError={() => {
                toast.error('Failed to load image');
              }}
            />
          ) : isPdf && documentUrl ? (
            <embed
              src={`${documentUrl}#view=FitH`}
              type="application/pdf"
              className="w-full h-[70vh]"
            />
          ) : documentUrl ? (
            <iframe 
              src={documentUrl} 
              className="w-full h-[70vh] border-0"
              title="Document Viewer"
              onError={() => {
                toast.error('Failed to load document');
              }}
            />
          ) : (
            <div className="flex flex-col items-center justify-center h-[70vh]">
              <FaFileAlt className="w-16 h-16 text-gray-400 mb-4" />
              <p className="text-gray-500">Could not load document</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Main TenantPopup Component
const TenantPopup = ({
  tenant,
  onClose
}: {
  tenant: Tenant;
  onClose: () => void;
}) => {
  const [imageToShow, setImageToShow] = useState<string | null>(null);
  const [documentViewer, setDocumentViewer] = useState({
    isOpen: false,
    url: '',
    
    type: '',
    
  });

  const handleImageClick = (tenantImageUrl: string | null) => {
    if (tenantImageUrl && tenantImageUrl.startsWith("http")) {
      setImageToShow(tenantImageUrl);
    } else {
      toast.error("No valid image available to view.");
    }
  };

  const handleDocumentClick = async (documentUrl: string | null) => {
    if (!documentUrl) {
      toast.error("No document available to view.");
      return;
    }

    // Determine the type of document
    const extension = documentUrl.split('.').pop()?.toLowerCase() || '';
    const isPdf = extension === 'pdf';
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(extension);
    
    setDocumentViewer({
      isOpen: true,
      url: documentUrl,
      type: isImage ? 'image' : (isPdf ? 'pdf' : 'document')
    });
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-7 rounded-lg w-96 relative max-h-[90vh] overflow-y-auto">
          <button onClick={onClose} className="absolute top-2 right-2 text-red-500">
            <MdClose size={24} />
          </button>
          <div className='flex justify-between gap-2 w-full border-b py-4 border-primary'>
            <img
              src={tenant?.tenantImageUrl || 'https://via.placeholder.com/150'}
              alt={tenant?.name}
              className="w-24 h-24 rounded-full mx-auto"
              onClick={() => handleImageClick(tenant.tenantImageUrl)}
              style={{ cursor: 'pointer' }}
            />
            <span className='flex flex-col justify-center gap-1 w-full'>
              <h2 className="text-start text-2xl font-bold ">{tenant?.name}</h2>
              <p className="text-start text-gray-600">{tenant?.occupation}</p>
            </span>
          </div>
          
          <div className="mt-4 space-y-2">
            <p><strong>Phone Number:</strong> {tenant?.contact}</p>
            {tenant?.email && <p><strong>Email:</strong> {tenant?.email}</p>}
            <p><strong>Property Name:</strong> {tenant?.propertyAddress?.propertyName ?? "N/A"}</p>
            <p><strong>Rent Due Date:</strong> {tenant?.dueDate}</p>
            <p><strong>Occupied Date:</strong> {tenant?.occupiedDate}</p>
            {tenant?.vacatedDate && 
            <p><strong>Vacated Date:</strong> {tenant?.vacatedDate}</p>}
            <p><strong>Deposit Amount:</strong> &#8377;{tenant?.propertyAddress?.propertyDepositAmount}</p>
            <p><strong>Rent:</strong>&#8377;{tenant?.propertyAddress?.propertyRent}</p>
            <p><strong>Opening Balance:</strong> &#8377;{tenant?.openingBalance}</p>
            <p><strong>Pending Opening Balance:</strong> &#8377;{tenant?.unPaidOpeningBalance || 0}</p>
            <p><strong>Pending Deposit Amount:</strong> &#8377;{tenant?.unaidDepositAmount || 0}</p>
            {tenant?.comments && <p><strong>Comments:</strong> {tenant?.comments}</p>}
            
            {tenant?.documentUrl && (
              <p className="mt-2">
                <strong>Document:</strong>
                <button
                  onClick={() => handleDocumentClick(tenant.documentUrl)}
                  className="text-blue-500 hover:underline ml-1 flex items-center"
                >
                  <FaFileAlt className="mr-1" /> View Document
                </button>
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Document Viewer Modal */}
      <DocumentViewer
        isOpen={documentViewer.isOpen}
        url={documentViewer.url}
        type={documentViewer.type}
         tenantId={tenant.id}
        onClose={() => setDocumentViewer({ isOpen: false, url: '', type: '' })}
      />

      {/* Image Viewer Modal */}
      {imageToShow && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setImageToShow(null)}
        >
          <div className="relative max-w-4xl max-h-[90vh]">
            <button 
              onClick={() => setImageToShow(null)}
              className="absolute top-2 right-2 text-white bg-black bg-opacity-50 rounded-full p-1"
            >
              <MdClose size={24} />
            </button>
            <img 
              src={imageToShow} 
              alt="Tenant" 
              className="max-w-full max-h-[90vh] object-contain"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default TenantPopup;